﻿import $ from 'jquery';
import { TemplateRow } from "./templaterow";
import { CloneRow } from "./clonerow"

export interface ITemplateRow {
  $row: JQuery;
  init(): void;
}

export class TemplateRowFactory {
  public static create($table: JQuery): ITemplateRow {
    if (TemplateRow.canBuild($table))
      return new TemplateRow($table);

    return new CloneRow($table);
  }
}
